export class loteriaEmpresaModel
{
    public cliente_id : number;
    public contenido_app : string;
    public donacion : number;
    public ficheros : any[]; //Si llegan a exitir modelo especifico cambiar por el
    public gastos_envio : string;
    public id : number;
    public numeros? : any[]; //Si llegan a exitir modelo especifico cambiar por el
    public numeros_list? : any[]; //Si llegan a exitir modelo especifico cambiar por el
    public pin : number;
    public pinRequiredInWeb : boolean;
    public precio_decimo : string;
    public sedes : any[]; //Si llegan a exitir modelo especifico cambiar por el
    public slug : string;
    public titulo : string;
    public url_redirect: string;
    public redirect: boolean;
    public historico: Historico;
    public sorteo_asociado: any;
    public logo_autoservicio: String;
    public autoservicio: Number;
    public autoservicio_confirmado: Number;
    public auto_renovacion: Number;
	public azureadactive?: boolean;
	public tenant_id?: string;
	public limite_texto?: string;
	public ac_data?: string;
	public ac_data_values?: string;
	public interfaz_limitada: boolean;
	public entidad: any;
	public facturas: boolean;
	public compra_minima: number;
	public laguinda: boolean;
    public patrocinadores?: any
    public coderequired?: boolean
    
    constructor(){}
}

class Historico
{
    public decimosVendidos: number;
    public formasEnvio: any[]
    public importeTotal: number;
    public importeTotalDonaciones: number;
    public usuariosTotalesCompra: number;
}